export default {
      id: "cog-hollow-usage",
      viewBox: "0 0 17.3 17.3",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#cog-hollow",
      toString: function () {
        return this.url;
      }
    }